export default __webpack_public_path__ + "static/media/share.924bf57d.svg";